export default __webpack_public_path__ + "static/media/store.d20b9f97.svg";